import styled from 'styled-components/macro';

import {
  CardContainer,
  CardHeader,
  CardItem,
  CardLabel,
  CardTitle,
  CardValue,
} from 'common/components/Card/card.styled';

export const Header = styled(CardHeader)`
  margin: ${({ theme }) => theme.spacing.two_1} 0 ${({ theme }) => theme.spacing.zero_2} 0;
`;

export const Title = styled(CardTitle)`
  font-size: ${({ theme }) => theme.fontSize.lg};
`;

export const Item = styled(CardItem)<{ padding?: string; border?: string }>`
  padding: ${({ theme, padding }) => (padding ? padding : `${theme.spacing.one} 0`)};
  border-bottom: ${({ theme, border }) => (border ? border : `1px solid ${theme.colors.black_20}`)};
`;

export const Label = styled(CardLabel)`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
`;

export const Container = styled(CardContainer)<{
  isInsideForm?: boolean;
  justifyContent?: string;
  padding?: string;
}>`
  ${({ theme, isInsideForm, justifyContent, padding }) =>
    isInsideForm &&
    `border: none; 
    margin: ${theme.spacing.zero}; 
    padding-top: 0; 
    padding-left: 0;
    ${padding ? `padding: ${padding};` : ''}
    
    ${Item} {
      border: none;
      padding: ${theme.spacing.zero};
      padding-bottom: ${theme.spacing.zero_2};
      justify-content: ${justifyContent ? justifyContent : 'flex-start'};
  }

  ${Label} {
    font-size: ${theme.fontSize.md};
    color: ${theme.colors.black_70};
    margin-right: ${theme.spacing.zero_2};
  }

  ${CardValue} {
    text-align: left;
  }
  `}

  ${Header}:first-child {
    margin-top: 0;
  }

  ${Item}:last-child {
    border: 0;
    padding-bottom: 0;
  }
`;
